var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteNumberedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-731.000000, -114.000000)",
    stroke: "currentColor",
    strokeWidth: 1.04347826
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-numbered-list",
    transform: "translate(731.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.79166667,1.56521739 L13,1.56521739",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79166667,6.26086957 L13,6.26086957",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79166667,10.9565217 L13,10.9565217",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.541666667,5.73913043 L0.541666667,5.47826087 C0.541666667,5.06086957 0.920833333,4.69565217 1.35416667,4.69565217 L1.35416667,4.69565217 C1.7875,4.69565217 2.16666667,5.06086957 2.16666667,5.47826087 L2.16666667,5.47826087 C2.16666667,5.63478261 2.1125,5.79130435 1.95,5.89565217 L0.541666667,7.2 L0.541666667,7.30434783 L2.70833333,7.30434783",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12 L1.35416667,12 C1.7875,12 2.16666667,11.6347826 2.16666667,11.2173913 L2.16666667,11.2173913 C2.16666667,10.8 1.7875,10.4347826 1.35416667,10.4347826 L1.08333333,10.4347826 L1.08333333,10.3826087 L1.625,9.49565217 L1.625,9.39130435 L0,9.39130435",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625,3.13043478 L1.625,0 L1.3,0 C1.3,0 0.8125,0.52173913 0.216666667,0.52173913",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteNumberedList);
export default __webpack_public_path__ + "static/media/icon-rte-numbered-list.6beb00c313168fc33f6d2c982b27250d.svg";
export { ForwardRef as ReactComponent };